import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { api } from "../lib/api";
import { persister } from "../lib/persist";

/** Uitloggen en de gegevens op dit apparaat wissen (gedeelde tablets). */
export function useLogout() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return async () => {
    await api("/auth/logout", { method: "POST" });
    // Wachtende wijzigingen blijven bewaard en worden pas weer verstuurd als dezelfde gebruiker inlogt.
    await persister.removeClient();
    qc.clear();
    navigate("/inloggen", { replace: true });
  };
}
